import {Injectable} from '@angular/core';
import {STORAGE_NAME} from '../constants/constants';
import jwt_decode from 'jwt-decode';
import {HttpClient, HttpParams} from '@angular/common/http';
import {environment} from '@env/environment';
import {tap} from 'rxjs';
import {generateCodeChallenge, generateCodeVerifier} from '../utils/utils';
import {CookieService} from "@app/core/services/cookie.service";

export interface ChangePasswordResponse {
  code: string;
  message: string;
  data: {
    duration: string;
    email: string;
  };
}
@Injectable({
  providedIn: 'root'
})
export class OtpService {

  constructor(private http: HttpClient, private cookieService: CookieService) {}

  public getOtpAndSendMail(data: any) {
    return this.http.post<ChangePasswordResponse>(`${environment.backend.sso}/v1/otp/generate`, data);
  }

  public resend(data: any) {
    return this.http.post<ChangePasswordResponse>(`${environment.backend.sso}/v1/otp/re-send`, data);
  }

}
